// import React, { Fragment, FunctionComponent } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faBath } from "@fortawesome/free-solid-svg-icons";
// import { Graphics, Description } from "../styles/agency-income-metrics-styles";

// const BathroomRenovation: FunctionComponent<unknown> = () => (
//   <Fragment>
//     <Graphics>
//       <FontAwesomeIcon icon={faBath} />
//     </Graphics>
//     <Description>
//       This could buy you: <br /> <span>a bathroom renovation</span>!
//     </Description>
//   </Fragment>
// );

// export default BathroomRenovation;
